/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import ShadowExample from '../examples/Shadows';
const ShadowExampleSource = require('!!raw-loader!../examples/Shadows');
export default class ShadowsPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Shadows"/>
                <h3>Shadows</h3>
                <p>
                    you can also quickly add or remove a shadow with our box-shadow utility classes. Includes support
                    for .shadow-none and three default sizes (which have associated variables to match).
                </p>
                <div className="docs-example">
                    <ShadowExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{ShadowExampleSource}</PrismCode>
                </pre>
            </div>);
    }
}
